import CasinoConfigProvider from './Providers/CasinoConfigProvider';
import ConfigProvider from './Providers/ConfigProvider';
import AppConfigProvider from './Providers/AppConfigProvider';
import SeoConfigProvider from './Providers/SeoConfigProvider';

/**
 * We don't have access to full process.env.*, we have to select certain keys if we want to use them
 */
class Config {
    private static instance: Config;
    private config: { [key: string]: string };

    private configProviders: ConfigProvider[] = [
        new AppConfigProvider(),
        new CasinoConfigProvider(),
        new SeoConfigProvider(),
    ];

    static getInstance(): Config {
        if (!Config.instance) {
            Config.instance = new Config();
        }

        return Config.instance;
    }

    constructor() {
        this.configProviders.forEach((provider) => {
            this.config = {
                ...this.config,
                ...provider.getConfig(),
            };
        });
    }

    public get(key: string): string {
        return this.config[key] ?? '';
    }

    public isTrue(key: string): boolean {
        return ['true', '1'].includes(this.get(key));
    }

    public isFalse(key: string): boolean {
        return ['false', '', '0'].includes(this.get(key));
    }

    public is(key: string, value: string): boolean {
        return this.get(key) === value;
    }

    public isNot(key: string, value: string): boolean {
        return !this.is(key, value);
    }
}

export default Config.getInstance();
